// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeController_inputRoot__SCFSs","arrowIcon":"DateRangeController_arrowIcon__2hC2S"};